import { createContext, useContext, ReactNode } from "react";

export enum ComparisonLabel {
  EMR = "EMR",
  Valerie = "Valerie",
}

interface ComparisonContextValue {
  comparisonLabel: ComparisonLabel;
}

const ComparisonContext = createContext<ComparisonContextValue | undefined>(undefined);

export function ComparisonProvider({ comparisonLabel, children }: ComparisonContextValue & { children: ReactNode }) {
  return <ComparisonContext.Provider value={{ comparisonLabel }}>{children}</ComparisonContext.Provider>;
}

export function useComparison() {
  const context = useContext(ComparisonContext);

  return context;
}
